import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserAccess } from '../hooks/useUserAccess';

function UploaderGuard({ children }) {
  const { canUpload, loading } = useUserAccess();

  if (loading) {
    return (
      <div className="status-card" style={{ textAlign: 'center', padding: 40 }}>
        <span className="status-title">Verificando permissões...</span>
      </div>
    );
  }

  if (!canUpload) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default UploaderGuard;
